<template>
  <el-input ref="input" v-model="value" type="textarea" :rows="rows" v-bind="params.inputProps" :style="{minWidth: minWidth + 'px!important'}" @blur="onBlur" @input="handleInput" />
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
import { getLength } from '@/utils'
export default Vue.extend({
  name: 'CargoAgGridCommonInputEditor',
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: '',
      type: 'input',
      disableEnter: true,
      minWidth: 200,
      rows: 5
    }
  },
  created() {
    console.log('oninputeditor')
    this.value = this.params.value
    if (this.params.fitContent) {
      const fontSize = this.params.fontSize || 12
      const lines = String(this.value).split('\n')
      // 设置宽度
      for (const line of lines) {
        const width = this.getTextWidth(line, fontSize)
        if (width > 200) {
          this.minWidth = 400
          break
        }
      }
      // 设置行数
      this.rows = 1 // 留出一行，作为空余
      for (const line of lines) {
        const width = this.getTextWidth(line, fontSize) + 50 // 留出部分宽度，容纳误差
        this.rows += Math.ceil(width / this.minWidth)
      }
      // 最小行数为5
      if (this.rows < 5) {
        this.rows = 5
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
  },
  methods: {
    getValue() {
      return this.value
    },
    onBlur() {
      console.log('input-stop',)
      this.params.api.stopEditing()
    },
    isPopup() {
      return true
    },
    getTextWidth(text, fontSize) {
      return getLength(String(text)) * 0.5 * fontSize // 文本字节数 * 0.5 * font-size
    },
    handleInput(value) {
      this.value = this.params.autoUppercase ? value.toUpperCase() : value
    }
  }
})
</script>
